/**
 * Converts verbose time strings to abbreviated format while keeping "ago"
 * Examples: "2 minutes ago" -> "2m ago", "1 hour ago" -> "1h ago", "1 minute ago" -> "1m ago"
 */
export function abbreviateTime(timeString?: string | null): string {
  if (!timeString) return "";

  return timeString.replace(
    /\b(\d+)\s+(\w+?)s?\s+(ago)\b/g,
    (_, num, unit, ago) => {
      const abbreviations: { [key: string]: string } = {
        second: "s",
        minute: "m",
        hour: "h",
        day: "d",
        week: "w",
        month: "mo",
        year: "y",
      };
      return `${num}${abbreviations[unit] || unit} ${ago}`;
    },
  );
}
